import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import RiskMetricTable from './RiskMetricTableWrapper';

const schema: JSONSchema7 = {
    title: 'Risk metric table',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        title: {
            type: 'string',
            description: 'Title for risk metric table',
            default: '',
        },
        headings: {
            type: 'string',
            description: 'Data for risk metric headings- expects Json',
            default: '',
        },
        tableData: {
            type: 'string',
            description: 'Data for risk metric body- expects Json',
            default: '',
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['title', 'headings', 'tableData'],
    },
];

const RiskMetricTableWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        title: {
            'ui:widget': 'ResourcePicker',
        },
    },
    templateView: RiskMetricTable,
    id: 'RiskMetricTable',
    group: 'table',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default RiskMetricTableWidget;
